import contentPathUrlMapper from '../src/utils/contentURLMapper';
import Head from 'next/head';

import ESI from '../src/components/ESI';
import logControl from '../src/utils/logger-utils/logControl';

function Content({ url, query }) {
  const path = query.path ? query.path : 'home';
  const contentPath = contentPathUrlMapper(url, false);
  return (
    <>
      <ESI src={contentPath} id={`content-renderer-${path}`} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { resolvedUrl, query, req } = context;
  logControl(context);

  return {
    props: {
      url: resolvedUrl,
      query,
    },
  };
}

export default Content;
